import { API_BASE_URL } from "../config";

const loginUser = async (username, password) => {
  const response = await fetch(`${API_BASE_URL}/auth/authenticate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ username, password })
    });
  
    if (!response.ok) {
      let message = "Error en la autenticación";
      try {
        const errorData = await response.json();
        message = errorData.message || message;
      } catch (e) {
        try {
          const rawText = await response.text();
          message = rawText || message;
        } catch (err) {}
      }
      throw new Error(message);
    }
  
    return await response.json();
  };
  
  export { loginUser };
  